/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import useGlobal from 'hooks/useGlobal';
import useCart from 'hooks/useCart';

import s from './customer-info-block.module.scss';

export default function CustomerInfo(props) {
  const { emit } = useGlobal();
  const { shippingAddress, shippingLine } = useCart();
  const customerInfo = {
    ...props.customerInfo,
    shippingAddress:
      props.customerInfo.shippingAddress || shippingAddress?.formatted,
    shippingLine: props.customerInfo.shippingLine || shippingLine
  };
  const handleEdit = (edit, step) => {
    emit.updateCb(prevState => ({
      checkout: {
        ...prevState.checkout,
        step,
        edit
      }
    }));
  };
  return (
    <div className={s.block}>
      <div className={s.blockWrapper}>
        <ul className={s.blockItem}>
          <li className={s.title}>Contact</li>
          <li className={s.info}>{customerInfo.email}</li>
          <li className={s.edit}>
            <button
              type="button"
              onClick={() => handleEdit('contact', 'shipping')}
            >
              Edit
            </button>
          </li>
        </ul>
        {customerInfo.shippingAddress && (
          <ul className={s.blockItem}>
            <li className={s.title}>Ship to</li>
            <li className={s.info}>
              {customerInfo.shippingAddress.join(', ')}
            </li>
            <li className={s.edit}>
              <button
                type="button"
                onClick={() => handleEdit('address', 'shipping')}
              >
                Edit
              </button>
            </li>
          </ul>
        )}
        {customerInfo.shippingLine && (
          <ul className={s.blockItem}>
            <li className={s.title}>Shipping</li>
            <li className={s.info}>
              {customerInfo.shippingLine?.title} -{' '}
              {Number(customerInfo.shippingLine?.priceV2?.amount) <= 0
                ? 'Free'
                : String(
                    Number(customerInfo.shippingLine?.priceV2?.amount).toFixed(
                      2
                    )
                  )}
            </li>
            <li className={s.edit}>
              <button
                type="button"
                onClick={() => handleEdit('shipping', 'payment')}
              >
                Edit
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}
